import {createStore, StoreApi} from 'zustand/vanilla';
import {RUN_FULL} from '../models/waypoint';

interface SearchFiltersState {
    run: string;
    query: string;
    setRun: (newRun: string) => void;
    setQuery: (newQuery: string) => void;
}

export type SearchFiltersStore = SearchFiltersState & StoreApi<SearchFiltersState>;

const store = createStore<SearchFiltersState>((set) => ({
    run: RUN_FULL,
    query: '',
    setRun: (newRun) => set((state) => ({
        ...state,
        run: newRun,
    })),
    setQuery: (newQuery) => set((state) => ({
        ...state,
        query: newQuery,
    })),
}));

export default (): SearchFiltersStore => ({
    ...store.getState(),
    ...store,
});
